<template>
  <f7-page class="no-swipeback" login-screen @page:reinit id="login" >
    <div class="body">
      <b-row class="h-100">
        <div class="position-absolute welcome-text-login">
          <h1 class="d-block text-center text-white" style="font-size:3rem !important">
            {{ $t('Homepage.connect_toolbox') }}
          </h1>
        </div>
        <div class="loginPanel loginHeight">
          <div>
            <b-row class="panel-heading ajust text-center mb-2rem">
              <b-col cols="2"></b-col>
              <b-col cols="8" class="p-2">
                <span class="navbar-brand mr-0 w-80">
                  <img :src="imgVarsLong" alt="DealPrudence" class="heritage largescreen w-100">
                  <!--<img :src="imgVarsShort" @click="loadAccueil" alt="VOP" class="heritage middlescreen">-->
                </span>
                <h4 class="panel-title" v-if="activationCode">
                  {{ $t('loginPage.sign_in_not_activated') }}
                </h4>
              </b-col>
              <b-col cols="2" class="p-0">
                <b-dropdown left class="no-back" toggle-class="border-0 m-md-2 z-5" variant="light" v-model="language" v-if="!flagTOOLBOX">
                  <template slot="button-content">
                    <img class="flag-nav" v-if="language === 'FR'" :src="logoFlagFR" alt=""/>
                    <img class="flag-nav" v-if="language === 'EN'" :src="logoFlagEN" alt=""/>
                    <img class="flag-nav" v-if="language === 'GB'" :src="logoFlagEN" alt=""/>
                    <img class="flag-nav" v-if="language === 'DE'" :src="logoFlagDE" alt=""/>
                    <img class="flag-nav" v-if="language === 'IT'" :src="logoFlagIT" alt=""/>
                    <img class="flag-nav" v-if="language === 'ES'" :src="logoFlagES" alt=""/>
                    <img class="flag-nav" v-if="language === 'PT'" :src="logoFlagPT" alt=""/><span class="">{{ labelLanguage }}</span>
                  </template>
                  <b-dropdown-item v-for="option in langOptions" :key="option.value" class="dropdown-item-web-header" @click="languageCountry(option.value)">
                    <img class="flag-nav" v-if="option.value === 'FR'" :src="logoFlagFR" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'GB'" :src="logoFlagEN" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'DE'" :src="logoFlagDE" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'IT'" :src="logoFlagIT" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'ES'" :src="logoFlagES" alt=""/>
                    <img class="flag-nav" v-else-if="option.value === 'PT'" :src="logoFlagPT" alt=""/>
                    <img class="flag-nav" v-else :src="logoFlagEN" alt=""/>
                    <span>{{option.text}}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-col>
            </b-row>
            <div @keyup.enter="quickLogin()" v-if="!mailSent">
              <!--DRO : Methode la plus simple pour régler le pb de l'affichage du mot de passe-->
              <!-- Message d'information pour mot de passe oublié -->
              <b-row v-if="isForgottenPassword && forgottenPasswordMessage">
                <b-col cols="8" offset="2" class="mb-3">
                  <div class="alert alert-info">
                    <i class="fa fa-info-circle"></i> {{ forgottenPasswordMessage }}
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login" id="Login"
                    inputType="text"
                    :inputLabel="$t('common.identifier')"
                    inputClass="inputLogin">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              <b-row v-if="!isForgottenPassword">
                <b-col cols="8" offset="2" class="form-group">
                  <div>
                    <label for="password">{{ $t('common.pwd') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Password"
                        id="password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="passwordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleVisibility">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="withPassword && !isForgottenPassword">
                <b-col class="form-group">
                  <div class="form-control passwordControl d-flex h-25px">
                    <input v-model="credentials.PasswordRepeat" class="border-0 w-100"
                      :type="passwordFieldType"
                      :placeholder="loginpage_PasswordRepeat">
                    </input>
                    <i class="icon icon-password"
                      :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                      @click="toggleVisibility">
                    </i>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="!isForgottenPassword">
                <b-col cols="8" offset="2" class="form-group">
                  <!-- <form-write-group-label-input v-model="credentials.Password"
                    isMandatory labelClass="mb-0"
                    inputType="password"
                    inputLabel="Mot de passe"
                    :inputIcon="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                    :placeholderValue="loginpage_Password">
                  </form-write-group-label-input> -->
                  <div>
                    <label for="password">{{ $t('common.totp') }}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Totp"
                        id="totp"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="TOTPFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isTOTPFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleVisibilityTOTP">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <!--<b-row v-if="!withPassword">
                <b-col cols="8" offset="2"  class="form-group p-0">
                  <a href="#" class="passwordForgot" @click="resetPassword" style="margin-left:20px;">Mot de passe oublié ?</a>
                </b-col>
              </b-row>-->
            </div>
            <div v-else>
              {{ $t('loginPage.email_forgotten_password_sent') }}
            </div>
            <b-row class="loginButtons" v-if="!mailSent">
              <b-col cols="8" offset="2">
                <b-button variant="primary" size="lg" id="submit-btn" v-if="!isForgottenPassword"
                  @click="authUser()">
                  {{ $t('loginPage.lgn_on_login_page') }}
                </b-button>
                <b-button variant="primary" size="lg" class="mb-3" id="submit-btn" v-if="isForgottenPassword"
                  @click="sendForgottenPasswordEmail()">
                  {{ $t('common.confirm') }}
                </b-button>
                <b-button variant="primary" size="lg" id="cancel-forgotten-password" v-if="isForgottenPassword"
                  @click="forgottenPasswordMode(false)">
                  {{ $t('common.cncl') }}
                </b-button>
              </b-col>
            </b-row>
            <b-row class="align-items-center justify-content-center" v-if="!isForgottenPassword">
              <span class="text-link" @click="forgottenPasswordMode(true)">{{ $t('loginPage.forgotten_pwd') }}</span>
            </b-row>
            <!-- <div class="login-method-separator">
              {{ $t('common.or_label_maj') }}
            </div> -->
            <!--<b-row class="loginButtons pt-3">
              <b-col cols="8" offset="2">
                <button class="loginGoogleButton  btn" size="lg"
                  @click="handleClickSignIn">
                  <div class="icon-google" style="display: inline-block;" v-if="false"></div>
                  <span style="vertical-align: middle; font-size: 13px;">
                    {{ $t('loginPage.login_ggl_sso') }}
                  </span>
                </button>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-center m-3">
                {{ $t('common.or_label_maj') }}
              </b-col>
            </b-row>
            <a class="signupLink" href="/register/">{{ $t('common.rgstr') }}</a>
            <cm-account-activation-popup :credentials="credentials">
            </cm-account-activation-popup>-->
            <footer class="pt-3 pb-1">
              <b-row>
                <b-col class="xs-12 text-center">
                  <b-col class="d-flex justify-content-center align-items-center">
                    <img class="logoStreammind" alt="Streammind" :src="logoStreammind"></img>
                    <span> {{ $t('common.copyright')}}</span>&nbsp;
                    <span>{{ version }}</span>
                  </b-col>
                </b-col>
              </b-row>
            </footer>
          </div>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import _ from 'underscore'

import conf from '../../config/config.dev.js'
// import moment from 'moment'
import designToolBox from '@/design/designToolBox.json'
import designDealprudence from '@/design/designDealprudence.json'

const flagTOOLBOX = conf.visual === 'TOOLBOX'

const design = flagTOOLBOX ? designToolBox : designDealprudence
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import CMAccountActivation from '@/popups/user/CMAccountActivation.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

import StreammindImageNoir from './../../assets/static/images/streammind-text-seul.png'
import StreammindImageBlanc from './../../assets/static/images/streammind-text-seul-blanc.png'
const StreammindImage = flagTOOLBOX ? StreammindImageNoir : StreammindImageNoir
import FlagFRImage from './../../assets/static/images/fr.png'
import FlagENImage from './../../assets/static/images/gb.png'
import FlagDEImage from './../../assets/static/images/de.png'
import FlagITImage from './../../assets/static/images/it.png'
import FlagESImage from './../../assets/static/images/es.png'
import FlagPTImage from './../../assets/static/images/pt.png'

export default {
  name: 'login',
  components: {
    'cm-account-activation-popup': CMAccountActivation,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    activationCodePassword: {
      default: 'notWithPassword',
      type: String
    }
  },
  data: () => {
    return {
      activationCode: '',
      connected: false,
      credentials: {
        Biometrics: {
          Voice: 'string',
          Video: 'string',
          Fingerprint: 'string'
        },
        ConnectBy: false,
        Login: '',
        Password: '',
        PasswordRepeat: '',
        Totp: ''
      },
      defaultService: 'Direct Debit',
      defaultUrl: '/home/',
      design: design.login,
      flagEPC: conf.visual === 'TOOLBOX',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      isForgottenPassword: false,
      forgottenPasswordMessage: '',
      isLargeScreen: true,
      langOptions: [],
      language: '',
      logoFlagFR: FlagFRImage,
      logoFlagEN: FlagENImage,
      logoFlagDE: FlagDEImage,
      logoFlagIT: FlagITImage,
      logoFlagES: FlagESImage,
      logoFlagPT: FlagPTImage,
      logoStreammind: StreammindImage,
      mailSent: false,
      passwordFieldType: 'password',
      TOTPFieldType: 'password',
      version: '',
      withPassword: false
    }
  },
  created () {
    this.defaultUrl = this.flagTOOLBOX ? '/homecarrousel/' : '/home/'
    this.language = this.$i18n.locale.toUpperCase()
    this.langOptions = [
      { value: 'EN', text: this.$t('lang.english')},
      { value: 'FR', text: this.$t('lang.french')}
    ]
    this.$bus.$off('refresh-inbox-list-cache')
    this.activationCode = new URL(location.href).searchParams.get('activationCode')
    this.withPassword = new URL(location.href).searchParams.get('withPassword')
    if (this.withPassword === 'true') {
      this.withPassword = true
    } else {
      this.withPassword = false
    }
    if (!this.activationCode) {
      this.activationCode = ''
    }
    this.loginpage_Identifier = this.$i18n.t('common.enter_identifier')
    this.loginpage_PasswordRepeat = this.$i18n.t('common.conf_pwd')
    this.loginpage_UnvalidEmail = this.$i18n.t('errors.unvalid_email_adr')
    if (this.withPassword) {
      this.loginpage_Password = this.$i18n.t('common.new_pwd')
    } else {
      this.loginpage_Password = this.$i18n.t('common.enter_pwd')
    }
    if (this.$engine.versionAPI) {
      this.version = 'Version ' + this.$engine.versionAPI
    } else {
      let that = this
      this.$engine.getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.$engine.versionAPI = resp.data.version
          if (that.$engine.versionAPI) {
            that.version = 'Version ' + that.$engine.versionAPI
          }
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    }
  },
  mounted () {
    if (!this.isLargeScreen) {
      this.$$('.navbar').addClass('deleteNavBar')
    }
    /* TLV 24/08/2020 Si l'utilisateur a déjà une session ouverte et n'est pas en
    * OTP, on le redirige vers la page d'accueil par défaut */
    if (this.$engine.auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('login', true)
      loadPage(this, {url: this.defaultUrl})
    }
  },
  computed: {
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    isTOTPFieldHidden () {
      return this.TOTPFieldType === 'password'
    },
    imgVars () {
      return this.design.fontImage
    },
    imgVarsLong () {
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    },
    labelLanguage () {
      let lang = this.language
      let langOpt = this.langOptions.filter(elem => elem.value.toLowerCase() === lang.toLowerCase())
      let label = this.language
      if (langOpt.length) {
        label = langOpt[0].value
      } else {
      }
      return label
    }
  },
  methods: {
    activateAccount (code) {
      this.$f7.showPreloader('Activating account')
      let that = this
      if (code !== '') {
        this.$engine.auth.activate(code, this.withPassword, this.credentials.Password)
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              this.authUser()
            }
          }).catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // this.showModalActivationCode()
            // that.Dom7('.accountActivationInput2').val(code)
          })
      } else {
        that.$f7.hidePreloader()
        that.$f7.alert('Please enter a valid activation code', 'Incorrect')
        this.showModalActivationCode()
      }
    },
    authUser () {
      if (this.$$('.modal-in').length) {
        return
      }
      if (this.withPassword) {
        if (this.credentials.Login === '') {
          this.$f7.alert('Login missing', 'Error')
          return
        } else if (this.credentials.Password === '') {
          this.$f7.alert('Password missing', 'Error')
          return
        } else if (this.credentials.PasswordRepeat === '') {
          this.$f7.alert('Password confirm missing', 'Error')
          return
        } else if (this.credentials.Password !== this.credentials.PasswordRepeat) {
          this.$f7.alert('Passwords do not match', 'Error')
          return
        }
      }
      let that = this
      this.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
      const creds = _.clone(this.credentials)
      creds.ConnectBy = 'lpc'
      if (this.withPassword) {
        creds.WithPassword = '1'
      }
      this.$engine.auth.login(creds)
      .then(resp => {
        that.$engine.user.connectBy = 'login-password-capi'
        that.connect()
      })
      .catch(err => {
        that.$f7.hidePreloader()
        if (that.activationCode.length > 0) {
          that.activateAccount(that.activationCode)
        } else {
          // Check for incomplete registration errors
          if (err.response && (err.response.status === 425 || err.response.status === 426)) {
            let message = that.$t('loginPage.account_not_activated')
            if (err.response.status === 425) {
              message = that.$t('loginPage.email_not_verified')
            } else if (err.response.status === 426) {
              message = that.$t('loginPage.totp_not_configured')
            }
            that.forgottenPasswordMessage = message
            that.forgottenPasswordMode(true)
            return
          }
          errorMessageAlert(err, that)
        }
      })
    },
    connect () {
      let defaultServiceId = parseInt(this.$engine.services.getServiceIdByName(this.defaultService)) - 1
      let that = this
      this.$bus.emit('login', true)
      this.$bus.emit('service:change', this.defaultService)
      this.$bus.emit('refresh-cache-menu')
      this.$f7.hidePreloader()
      this.$$('.panel-overlay').css('z-index', '')
      this.$$('.deleteNavBar').removeClass('deleteNavBar')
      that.connected = true
      loadPage(this, {url: (this.flagTOOLBOX ? '/homecarrousel/' : '/home/')})
    },
    forgottenPasswordMode (activate) {
      this.isForgottenPassword = activate
      if (!activate) {
        this.forgottenPasswordMessage = ''
      }
    },
    handleClickSignIn () {
      let that = this
      // On se conecte via Google
      this.$gAuth.signIn()
      .then(GoogleUser => {
        var gu = GoogleUser.getBasicProfile()
        var FirstName = gu.getGivenName()
        var LastName = gu.getFamilyName()
        var Login = gu.getEmail()
        var Password = gu.getId()
        this.$engine.user.connectBy = 'vue-google-oauth2'
        // est-ce qu'on est inscrit ? pour cela, on essait de se connecter
        that.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
        const creds = _.clone(that.credentials)
        creds.Login = Login
        creds.Password = Password
        creds.ConnectBy = 'vgo'
        this.$engine.auth.login(creds)
        .then(resp => {
          // J'existe
          this.connect()
        }).catch(() => {
          // On fail do something
          that.$f7.hidePreloader()
          this.$engine.auth.getLogin(Login, 'lpc')
          .then(() => {
            // Le compte existe en mode lpc.
            that.$f7.alert('The email sent by Google is already present in the database', 'Log in with your account')
          })
          .catch(err => {
            loadPage(that, {url: '/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password})
          })
        })
      })
      .catch(err => {
        // On fail do something
        if (err === false) {
          this.connect()
        }
      })
    },
    languageCountry (language) {
      this.language = language
      if (language === 'EN') {
        this.$i18n.locale = 'en'
      }
      else if (language === 'GB') {
        this.$i18n.locale = 'gb'
      }
      else if (language === 'ES') {
        this.$i18n.locale = 'es'
      }
      else if (language === 'IT') {
        this.$i18n.locale = 'it'
      }
      else if (language === 'DE') {
        this.$i18n.locale = 'de'
      }
      else if (language === 'PT') {
        this.$i18n.locale = 'pt'
      } else {
        this.$i18n.locale = 'fr'
      }
      this.langOptions = [
        { value: 'EN', text: this.$t('lang.english')},
        { value: 'FR', text: this.$t('lang.french')}
      ]
    },
    quickLogin () {
      if (this.isForgottenPassword) {
        this.sendForgottenPasswordEmail()
      } else if (!this.connected && this.credentials.Login.length !== 0 && this.credentials.Password.length !== 0 && !this.$$('.modal-in').length) {
        this.authUser()
      }
    },
    resetPassword () {
      this.$f7.popup('#cm-user-reset-password-true')
    },
    sendAnotherCode () {
      let that = this
      this.$f7.showPreloader('Sending')
      this.$engine.auth.getNewActivationCode()
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.alert('New activation code sent!', 'Ok')
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, this)
        })
    },
    sendForgottenPasswordEmail () {
      let that = this
      if (this.credentials.Login === '') {
        this.$f7.alert('Login missing', 'Error')
        return
      }
      this.$f7.showPreloader()
      this.$engine.auth.forgottenPassword({
        Login: this.credentials.Login
      })
      .then(resp => {
        this.$f7.hidePreloader()
        this.mailSent = true
        this.forgottenPasswordMessage = ''
      })
      .catch(err => {
        this.$f7.hidePreloader()
        errorMessageAlert(err, that)
      })
    },
    showModalActivationCode () {
      let that = this
      that.$$('.blueConfirmationButtonActivationOK2').on('click')
      that.$f7.modal({
        title: 'Activate Account',
        text: 'Please enter your activation code',
        afterText: '<input class="accountActivationInput2" type="text"><p class="blueConfirmationButtonActivationOK2">OK</p>',
        buttons: [
          {
            text: 'Cancel',
            onClick: function () {
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          },
          {
            text: 'Send new code',
            onClick: function () {
              that.sendAnotherCode()
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          }
        ]
      })
      that.$$('.blueConfirmationButtonActivationOK2').on('click', function (e) {
        that.$f7.closeModal()
        that.activateAccount(that.Dom7('.accountActivationInput2').val())
      })
    },
    toggleVisibility ($event) {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    toggleVisibilityTOTP ($event) {
      if (this.TOTPFieldType === 'password') {
        this.TOTPFieldType = 'text'
      } else {
        this.TOTPFieldType = 'password'
      }
    }
  }
}
</script>
